import React from 'react';
import {
	TypingIndicatorWrapper,
	TypingIndicatorAvatarSlot,
	TypingIndicatorBubble,
	TypingIndicatorDot,
} from './AIChat.Styled';

export type AIChatTypingIndicatorProps = {
	assistantAvatarSrc?: string;
};

export function AIChatTypingIndicator({ assistantAvatarSrc }: AIChatTypingIndicatorProps): React.ReactElement {
	const showAvatar = Boolean(assistantAvatarSrc);
	return (
		<TypingIndicatorWrapper role="status" aria-label="Assistant is typing">
			<TypingIndicatorAvatarSlot
				$visible={showAvatar}
				style={showAvatar ? { backgroundImage: `url(${assistantAvatarSrc})` } : undefined}
			/>
			<TypingIndicatorBubble>
				<TypingIndicatorDot $delay={0} />
				<TypingIndicatorDot $delay={150} />
				<TypingIndicatorDot $delay={300} />
			</TypingIndicatorBubble>
		</TypingIndicatorWrapper>
	);
}
